import React, { useState } from "react";

import { Bot, Loader2 } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";

import { useToast } from "../../components/hooks/use-toast";
import { useAiModel } from "../../components/hooks/useAiModel";

import AutoResizeTextarea from "../../components/AutoResizeTextarea";

import functionsService from "../../services/functionsService";

const HazardSFAIRPStatement = ({ project, hazard, setHazard }) => {
  const [isGeneratingSfairpStatement, setIsGeneratingSfairpStatement] =
    useState(false);

  const [selectedModel] = useAiModel();
  const { toast } = useToast();

  const handleChange = (name, value) => {
    setHazard((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const generateSfairpStatement = async () => {
    setIsGeneratingSfairpStatement(true);

    try {
      const { success, sfairpStatement } =
        await functionsService.generateHazardSFAIRP(
          project.id,
          hazard.description,
          hazard.type,
          hazard.hazardSource,
          hazard.causes,
          hazard.consequences,
          hazard.unmitigatedRisk,
          hazard.mitigations,
          hazard.retainedRisk,
          selectedModel
        );

      if (!success) {
        console.error("Failed to generate SFAIRP statement.");

        toast({
          variant: "destructive",
          title: "Failed to generate SFAIRP statement.",
        });
        return;
      }

      setHazard((prev) => ({
        ...prev,
        sfairpStatement,
      }));
    } catch (error) {
      console.error("Failed to generate SFAIRP statement:", error);

      toast({
        variant: "destructive",
        title: "Failed to generate SFAIRP statement.",
        description: error.message,
      });
    } finally {
      setIsGeneratingSfairpStatement(false);
    }
  };

  return (
    <div className="space-y-4">
      <Label>SFAIRP Statement</Label>

      <AutoResizeTextarea
        value={hazard.sfairpStatement}
        onChange={(e) => handleChange("sfairpStatement", e.target.value)}
        placeholder="Enter SFAIRP statement..."
      />

      <Button
        onClick={generateSfairpStatement}
        disabled={isGeneratingSfairpStatement}
      >
        {isGeneratingSfairpStatement ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <Bot className="mr-2 h-4 w-4" />
        )}
        Generate SFAIRP Statement
      </Button>
    </div>
  );
};

export default HazardSFAIRPStatement;
